module.exports = __webpack_public_path__ + "313789aa487197701405cea552438d9a.MP3";